/**
 * @file 标记他人号码
 * @author
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button, Carousel} from 'antd';

import needLoginList from '../../constants/needLoginList';
import {getQueryString, recordProxy} from '../../util';
import {fetchCreateTopic} from '../../actions/homeAction';

import img1 from './imgs/3.png';
import img2 from './imgs/1-1.png';
import img3 from './imgs/4.png';
import img4 from './imgs/4-1.png';
import img5 from './imgs/5.png';
// import imgSuccess from './imgs/success.png';
// import imgErr from './imgs/err.png';

import './markErr.less';
export class NumErr extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            value: '',
            off: false,
            phone: '',
            pageObj: {},
            // qualityModalVisible: false,
            phoneList: [],
            phoneValue: null,
            radioValue: '',
            descErr: false,
            selectErr: false,
            radioErr: false
        };
    }

    componentDidMount() {
        const searchUrl = getQueryString('phones');
        let phoneListTemp = [];
        if (searchUrl) {
            try {
                phoneListTemp = JSON.parse(decodeURIComponent(getQueryString('phones')));
            } catch (e) {
                console.log('e');
                console.log(e);
            }
        }
        this.setState({phoneList: phoneListTemp});
    }
    // componentWillUnmount() {
    //     // this.props.cleanMark();
    // }
    login = () => {
        const isDev = window.location.href.indexOf('haoma.baidu.com') > -1 ? false : true;
        const ele = document.createElement('a');
        ele.href = `https://passport${isDev ? '.qatest' : ''}.baidu.com/v2/?login&u=${
            encodeURIComponent(window.location.href)
        }`;
        ele.click();
    };
    jump = (item) => {
        const {userInfo = {}} = this.props;
        const locationSearch = window.location.search;
        let tempParam = '?pagef=numErr';
        if (locationSearch) {
            tempParam = locationSearch + '&pagef=numErr';
        }
        recordProxy('url-' + item.routerPath.replace('/', ''), 'click', '立即前往');
        if (needLoginList.includes(item.routerPath) && userInfo.code !== 200) {
            this.login();
        } else {
            this.props.history.push(item.routerPath + tempParam);
        }
    };
    // onQualityCallback = () => {
    //     this.setState({qualityModalVisible: true});
    // }
    // onSelectPhone = (value) => {
    //     this.setState({phoneValue: value, selectErr: false});
    // }
    // onRadioChange = (e) => {
    //     this.setState({radioValue: e.target.value, radioErr: false});
    // }
    // onDescChange = (e) => {
    //     this.setState({descValue: e.target.value, descErr: false});
    // }
    // onSubmit = () => {
    //     const {phoneValue, radioValue, descValue} = this.state;
    //     if (!phoneValue) {
    //         this.setState({selectErr: true});
    //         return;
    //     }
    //     if (!radioValue) {
    //         this.setState({radioErr: true});
    //         return;
    //     }
    //     if (radioValue === '3' && !descValue) {
    //         this.setState({descErr: true});
    //         return;
    //     }
    //     recordProxy('feedback', 'submit', 'numErr');
    //     let json = {
    //         phone: [].concat(phoneValue),
    //         topic_type: +radioValue
    //     };
    //     if (descValue) {
    //         json.content = descValue;
    //     }
    //     const fetchCreateTopic = (params) => this.props.fetchCreateTopic({
    //         ...json,
    //         ...params
    //     }).then(data => {
    //         if (data.code === 200) {
    //             message.success('提交成功');
    //             this.setState({qualityModalVisible: false});
    //         } else {
    //             message.error('提交失败');
    //             this.setState({qualityModalVisible: false});
    //         }
    //     });
    //     bCat_2055_request(fetchCreateTopic);
    // }
    render() {
        // const {phoneList, phoneValue, radioValue, descValue, selectErr, radioErr, descErr} = this.state;
        const cardList = [
            {
                logo: img1,
                cardTitle: '号码占用申诉',
                cardDesc: '个人、企业、政府被占用，可申诉取消',
                cardShowLogo: img2,
                cardShowTitle: '北京 中国移动',
                cardShowTip: '184 **** 6512',
                goUrl: '/occupy'
            }, {
                logo: img3,
                cardTitle: '认证信息修改',
                cardDesc: '已认证企业或政府号码修改',
                cardShowLogo: img4,
                cardShowTitle: '百度地图',
                cardShowTip: '400 **** 9999',
                // tag: '用户标记',
                goUrl: '/verify_msg'
            }, {
                logo: img5,
                cardTitle: '号码质量反馈',
                cardDesc: '平台号码错误，号码为空号等问题',
                goUrl: '/feedback'
            }
        ];
        return (
            <div className={'mark-err-page'}>
                <div className="banner">
                    <Carousel className="custom-carousel-class" autoplay>
                        <div className="mark-carousel-item carousel-item">
                            <div className="item-info-wrapper">
                                <p className="title">号码报错</p>
                                <p className="title-tip">以下号码信息存在错误，请选择要进行的服务</p>
                            </div>
                        </div>
                    </Carousel>
                </div>
                <div className="line-content">
                    <div className="line1"></div>
                    <div className="line-title">选择服务</div>
                    <div className="line2"></div>
                </div>
                <div className="card-content">
                    {cardList.map((val, key) => {
                        return (<div className="card-item" key={key}>
                            <div className="card-logo">
                                <img src={val.logo} />
                            </div>
                            <div className="card-title">{val.cardTitle}</div>
                            <div className="card-desc">{val.cardDesc}</div>
                            {val.cardShowTitle && <div className="card-tip">完成效果</div>}

                            {val.cardShowTitle && <div className="card-show">
                                <div className="card-show-logo">
                                    <img src={val.cardShowLogo} />
                                </div>
                                <div className="card-show-cont">
                                    <div className="card-show-title">
                                        {val.cardShowTitle}
                                        {val.tag && <span className="card-show-tag">{val.tag}</span>}
                                    </div>
                                    <div className="card-show-tip">{val.cardShowTip}</div>
                                </div>
                            </div>}
                            <Button
                                className="goBtn"
                                type="primary"
                                onClick={() => this.jump({routerPath: val.goUrl})}
                            >立即前往</Button>
                        </div>);
                    })}
                    {/* <div className="card-item">
                        <div className="card-logo">
                            <img src={img5} />
                        </div>
                        <div className="card-title">号码质量反馈</div>
                        <div className="card-desc">平台号码错误，号码为空号等问题</div>
                        <Button
                            className="goBtn"
                            type="primary"
                            onClick={() => this.jump({routerPath: val.goUrl})}
                            // onClick={this.onQualityCallback.bind(this)}
                        >立即前往</Button>
                    </div> */}
                </div>
                {/* <Modal
                    title="号码质量反馈"
                    mask={false}
                    className="quality-callback-modal"
                    // getContainer={false}
                    width={380}
                    visible={this.state.qualityModalVisible}
                    okText={'提交'}
                    cancelText={'取消'}
                    onOk={this.onSubmit}
                    onCancel={() => this.setState({qualityModalVisible: false})}
                >
                    <div className="quality-callback-content">
                        <p className="title-type-1">问题号码</p>
                        <Select
                            value={phoneValue}
                            onChange={this.onSelectPhone}
                            style={{width: 340, height: 44}}
                            placeholder="请选择"
                        >
                            {phoneList.map(val => {
                                return <Option key={val.phone} value={val.phone}>
                                    {val.phone}{val.name ? `(${val.name})` : ''}
                                </Option>;
                            })}
                        </Select>
                        {selectErr && <p className="err-tip">请选择问题号码</p>}
                        <p className="title-type-2">问题类型</p>
                        <Radio.Group
                            value={radioValue}
                            onChange={this.onRadioChange}
                        >
                            <Space direction="vertical">
                                <Radio value="1">空号</Radio>
                                <Radio value="2">非该企业号码</Radio>
                                <Radio value="3">其他原因</Radio>
                            </Space>
                        </Radio.Group>
                        {radioErr && <p className="err-tip">请选择问题类型</p>}
                        <p className="title-type-1" style={{marginTop: '30px'}}>问题说明</p>
                        <TextArea
                            value={descValue}
                            onChange={this.onDescChange}
                            placeholder="请详细说明问题，以便我们定位与解决"
                            autoSize={{minRows: 3, maxRows: 5}}
                        />
                        {descErr && <p className="err-tip">请输入问题说明</p>}
                    </div>
                </Modal> */}
            </div>
        );
    }

}
function mapStateToProps(state) {
    return {
        userInfo: state.userInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCreateTopic: obj => fetchCreateTopic(dispatch, obj)
    };
}
NumErr.propTypes = {
    history:PropTypes.object,
    fetchCreateTopic: PropTypes.func,
    userInfo: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NumErr));
